import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'mtn-not-available',
  templateUrl: './not-available.component.html',
  styleUrls: ['./not-available.component.scss']
})
export class NotAvailableComponent {

  constructor() {
  }



}
